import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { getPreferenceDefaults } from './config.js';
import { LOAD_PREFERENCES, RESET_PREFERENCES, UPDATE_PREFERENCE } from './actions.js';

var preferences = function preferences() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getPreferenceDefaults();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case UPDATE_PREFERENCE:
      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, action.key, action.value));

    case RESET_PREFERENCES:
      return getPreferenceDefaults();

    case LOAD_PREFERENCES:
      return _objectSpread2(_objectSpread2({}, state), action.values);

    default:
      return state;
  }
};

export { preferences as default };
